import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** @see docs/API_SYSTEM_ACCESS.md */
export async function deleteRole(id) {
  const { data: raw } = await request.delete(`/system/role/${id}`);
  return parseVer4DetailResponse(raw);
}
